import { withAuth } from 'hocs/auth/with-auth';
import { AlbumViewMode } from './album-view-mode';

// The public view mode (/view-mode/album/:albumId, /view-mode/content/:contentId,
// /view-mode/vault/:vaultId): shared links and QR codes. Signing in is
// optional; it's only checked so the top bar can offer "My vaults".
const PublicViewScreen = withAuth(AlbumViewMode, true);

export { PublicViewScreen };
